import { render, staticRenderFns } from "./elements.vue?vue&type=template&id=303888fa&scoped=true"
import script from "./elements.vue?vue&type=script&lang=js"
export * from "./elements.vue?vue&type=script&lang=js"
import style0 from "./elements.vue?vue&type=style&index=0&id=303888fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303888fa",
  null
  
)

export default component.exports